import { CahierJournalView } from 'containers/CahierJournal/types';
import { getFromAndTo } from 'containers/CahierJournal/utils/getFromAndTo';
import { doesDayBelongToWorkingDays } from 'containers/CahierJournal/utils/doesDayBelongToWorkingDays';
import { getNextDayBasedOnWorkingDays } from 'utils/time';
import isBefore from 'utils/time/isBefore';
import isAfter from 'utils/time/isAfter';
import isEqual from 'utils/time/isEqual';

export function getInitialDate(
  currentDate: Date,
  selectedDate: Date,
  workingDays: number[],
  view: CahierJournalView,
) {
  const { from, to } = getFromAndTo(view, selectedDate, workingDays);
  const dayBelongToWorkingDays = doesDayBelongToWorkingDays(
    currentDate,
    workingDays,
  );
  const getDayForWeekAnd2DaysView = () => {
    if (
      (isBefore(from, currentDate) && isAfter(to, currentDate)) ||
      isEqual(currentDate, from) ||
      isEqual(currentDate, to)
    ) {
      if (dayBelongToWorkingDays) {
        return currentDate;
      }
      return getNextDayBasedOnWorkingDays(currentDate, workingDays);
    }
    return selectedDate;
  };
  switch (view) {
    case 'day':
      return selectedDate;
    case 'week':
      return getDayForWeekAnd2DaysView();
    case '2days':
      return getDayForWeekAnd2DaysView();
  }
}
